import { Route, Routes} from "react-router-dom";
import React from 'react';
import ContactBreadCrumbs from './ContactBreadCrumbs';
import ContactSelfHelp from './ContactSelfHelp';
import ContactSolution from './ContactSolution';
import ContactOptions from './ContactOptions';
import ContactOptionChat from './ContactOptionChat';
import ContactOptionPhone from './ContactOptionPhone';

const ContactApp = (props) => {

  const getContent = (lg, ct) => {
    const contentImport = require('../../../../config/locales/contact.json');
    // Check if there is content that corresponds to the current language
    if (typeof contentImport[lg] !== "undefined") {
      // Check if there is content that corresponds to the current language+country
      if (typeof contentImport[lg][ct] !== "undefined") {
        return contentImport[lg][ct]
      } else {
        // Returning the first country that corresponds to the language as country returns undefined
        const fallBackCountry = Object.keys(contentImport[lg])[0];
        return contentImport[lg][fallBackCountry]
      }
    } else {
      return contentImport["en"]["us"]
    }
  }

  const content = getContent(nortonAnalytics.site_language, nortonAnalytics.site_country);
  const contentStrings = content['contactStrings'];
  const relativeUrl = props.layout ?
    "/osp/"+nortonAnalytics.site_language+"/"+nortonAnalytics.site_country+"/contact/"+props.layout :
    "/osp/"+nortonAnalytics.site_language+"/"+nortonAnalytics.site_country+"/contact";

  const setContentSelfHelp = () => {
    return (content['selfHelpSolutions'][props.layout]) ? (content['selfHelpSolutions'][props.layout]) : content['selfHelpSolutions']['default'];
  }

  const setContactHeader = (layout) => {
    if ( (layout) && (typeof contentStrings['header_'+layout] !== "undefined") ) {
      return contentStrings['header_'+layout]
    } else {
      return contentStrings['header']
    }
  }

  return (
    <div id="contact">
      <div id="contact-header">{setContactHeader(props.layout)}</div>

        <ContactBreadCrumbs
          contentStrings = {contentStrings}
          relativeUrl = {relativeUrl}
        />

        <Routes>
          <Route exact path={relativeUrl} element={
            <ContactSelfHelp
              contentStrings = {contentStrings}
              contentSelfHelp = {setContentSelfHelp()}
              relativeUrl = {relativeUrl}
            />
          }/>
          <Route exact path={relativeUrl+"/solutions/:docid"} element={
            <ContactSolution
              contentStrings = {contentStrings}
              layout = {props.layout}
              relativeUrl = {relativeUrl}

            />
          }/>
          <Route exact path={relativeUrl+"/options"} element={
            <ContactOptions
              contentStrings = {contentStrings}
            />
          }/>
          <Route exact path={relativeUrl+"/options/chat"} element={
            <ContactOptionChat
              contentStrings = {contentStrings}
            />
          }/>
          <Route exact path={relativeUrl+"/options/phone"} element={
            <ContactOptionPhone
              contentStrings = {contentStrings}
              layout = {props.layout}
              relativeUrl = {relativeUrl}
            />
          }/>
        </Routes>

      </div>
    )
  };

export default ContactApp;
